import { defineStore } from 'pinia';
import { SET_SHOW_INTERNATIONAL_CONTEXT_FORM, SET_SLIDEOUT_ID, SET_POPUP_MEDIA_CONTENT } from '#shared/types/actions';

export const useNavShared = defineStore('navShared', {
  state: () => ({
    showInternationalContextForm: false,
    slideoutId: '',
    popupMediaContent: null,
  }),
  actions: {
    [SET_SHOW_INTERNATIONAL_CONTEXT_FORM](payload) {
      this.showInternationalContextForm = payload;
    },
    [SET_SLIDEOUT_ID](payload) {
      this.slideoutId = payload;
    },
    [SET_POPUP_MEDIA_CONTENT](payload) {
      this.popupMediaContent = payload;
    },
  },
});
